module.exports = __webpack_public_path__ + "static/media/dish_selected.027cad15.svg";